<!-- 开票回款信息面板 -->
<template>
  <div>
    <p><b>回款状态：</b>{{ receivedPaymentStatus }}</p>
    <div style="margin: 18px 0">
      <span><b>待回款金额</b> ￥{{ (taxedTotalAmount - form.collection_total) | seperateThousandsToFixed(2) }} </span>
      <span><b>已回款金额</b> ￥{{ form.collection_total | seperateThousandsToFixed(2) }}</span>
      <el-button v-if="showFinishReFundButton"
                 style="margin-left: 20px"
                 size="mini"
                 type="primary"
                 @click="onFinishReceivedPayment">完成回款
      </el-button>
    </div>
    <div v-for="(item, index) in form.received_details"
         :key="index">
      <div style="margin: 18px 0">
        <span><b>回款详情{{ index + 1 }}.</b> {{ item.created_at }}</span>
        <span style="margin-left: 10px">{{ item.creator_name }}</span>
        <span style="margin-left: 10px">关联回款 ￥{{ item.assoc_amount }}</span>
        <router-link :to="redirectToCollectionPage(item)">
          <span style="margin-left: 10px">回款条目ID：{{ item.collection_id }}</span>
        </router-link>
      </div>
      <el-table :data="[item]">
        <el-table-column
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          prop="type"
          label="开票类型">
        </el-table-column>
        <el-table-column
          prop="id"
          label="项目名称/编号">
          <template slot-scope="scope">
            <template v-if="form.issued_type * 1 === 1">
              {{ scope.row.project_name }}/{{ scope.row.project_number }}
            </template>
            <template v-if="form.issued_type * 1 === 2">
              {{ scope.row.virtual_project.name }}/{{ scope.row.virtual_project.number }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="complete_rate"
          label="项目完成率">
        </el-table-column>
        <el-table-column
          prop="do_number"
          label="DO/PO单号">
        </el-table-column>
        <el-table-column
          prop="budget"
          label="项目预算">
          <template slot-scope="scope">
            {{ symbol }}{{ scope.row.budget | seperateThousandsToFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cost"
          label="项目成本">
          <template slot-scope="scope">
            {{ symbol }}{{ scope.row.cost | seperateThousandsToFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cost_type"
          label="开票名称">
          <template slot-scope="scope">
            <span>{{ scope.row.invoice_full_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_type"
          label="开票金额依据">
          <template slot-scope="scope">
                <span v-for="item in options.tax_type"
                      v-if="scope.row.tax_type === item.value">{{ item.label }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_rate"
          label="税率">
          <template slot-scope="scope">
            {{ scope.row.tax_rate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="回款金额">
          <template slot-scope="scope">
            <span> {{ symbol }}{{ scope.row.assoc_amount | seperateThousandsToFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_at"
          label="回款日期">
          <template slot-scope="scope">
            <span>{{ scope.row.received_date | formatOnlyDate }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isFromFinance: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      options: state => state.invoiceApply.options,
    }),
    taxedTotalAmount () {
      return this.form.detail.reduce((total, current) => {
        return total + Number(current.total)
      }, 0)
    },
    showFinishReFundButton () {
      return [0, 1].includes(this.form.received_payment_status) &&
        this.$route.query.from === 'approve' &&
        [1, 5].includes(Number(this.user.usertype))
    },
    receivedPaymentStatus () {
      return (this.options.received_payment_status.find(option => option.value === this.form.received_payment_status) || {}).label
    }
  },
  data () {
    return {
      symbol: '￥',
    }
  },
  created () {},
  watch: {},
  methods: {
    onFinishReceivedPayment () {
      this.$confirm(`警告：强制完成回款后，当前开票申请单将强制进入已回款状态，无法继续进行回款操作，请确认已关联金额：${this.form.collection_total} 元是否正确，是否继续强制完成回款？`, '完成回款操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.common('newCompleteReceivedPayment', {id: this.$route.params.id}).then((res) => {
          this.$message.success('完成回款成功')
          this.$router.go(0)
        })
      })
    },
    redirectToCollectionPage (item) {
      if (this.isFromFinance) {
        return `/received-approval/detail/${item.collection_id}`
      }
      return `/received-payment/detail/${item.collection_id}`
    },
  },
}
</script>

<style lang="scss">
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceCollectionLayout.vue